export const REDEEM_TABLE_HEADERS = [
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
    { label: '', colspan: 1 },
];

export const  REDEEM_TABLE_SUB_HEADERS = [
  { label: 'TRANSACTION ID', key: 'transactionId' },
  { label: 'FIRST NAME', key: 'firstName' },
  { label: 'MIDDLE NAME', key: 'middleName' },
  { label: 'LAST NAME', key: 'lastName' },
  { label: 'PHONE NUMBER', key: 'phoneNumber' },
  { label: 'PRODUCT NAME', key: 'productName' },
  { label: 'PRODUCT CODE', key: 'productCode' },
  { label: 'RECIPIENT NUMBER / EMAIL', key: 'recipient' },
  { label: 'REWARD POINTS USED', key: 'rewardPointsUsed' },
  { label: 'DATE/TIME', key: 'dateTime' },
  { label: 'STATUS', key: 'status' },
];


export const BUYLOAD_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];

export const BUYLOAD_TABLE_SUB_HEADERS = [
  { label: 'TRANSACTION ID',    key: 'transactionId' },
  { label: 'NAME',              key: 'firstName' },
  { label: 'PHONE NUMBER',      key: 'phoneNumber' },
  { label: 'RECIPIENT NUMBER',  key: 'recipientNumber' },
  { label: 'PRODUCT ID',        key: 'productId' },
  { label: 'SERVICE PROVIDER',  key: 'networkProvider' },
  { label: 'LOAD PROVIDER',     key: 'loadProvider' },
  { label: 'AMOUNT',            key: 'amount' },
  { label: 'DATE / TIME',       key: 'dateTime' },
  { label: 'STATUS',            key: 'status' },
  { label: 'TRACE NO.',         key: 'traceNo'},
  { label: 'ITEM TYPE',         key: 'itemType' },
  { label: 'MODIFIED DATE/TIME', key: 'modifiedDateTime' },
  { label: 'ERROR MESSAGE',     key: 'buyloadErrorMsg', sortable: false  },
  { label: 'ACTIONS', key: null, sortable: false, centered: true }
];

export const CASHIN_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];

export const CASHIN_TABLE_SUB_HEADERS = [
  { label: 'TRANSACTION ID',     key: 'transactionId' },
  { label: 'DATE / TIME',        key: 'dateTime' },
  { label: 'NAME',                key: 'firstName' },
  { label: 'PHONE NUMBER',       key: 'phoneNumber' },
  { label: 'CARD NUMBER',        key: 'cardNumber' },
  { label: 'PAYMENT METHOD',     key: 'paymentMethod' },
  { label: 'STATUS',             key: 'status' },
  { label: 'AMOUNT',             key: 'amount' },
  { label: 'CASH IN CHARGE',     key: 'cashInCharge' },
  { label: 'MODIFIED DATE/TIME', key: 'modifiedDateTime' },
  { label: 'ACTION', sortable: false, centered: true }
];

export const PAYBILLS_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];


export const PAYBILLS_TABLE_SUB_HEADERS = [
  { label: 'TRANSACTION ID',     key: 'transactionId' },
  { label: 'DATE / TIME',        key: 'dateTime' },
  { label: 'NAME',               key: 'firstName' },
  { label: 'PHONE NUMBER',       key: 'phoneNumber' },
  { label: 'ACCOUNT NUMBER',     key: 'accountNumber' },
  { label: 'ACCOUNT NAME',       key: 'accountName' },
  { label: 'BILLER NAME',        key: 'billerName' },
  { label: 'CATEGORY',           key: 'category' },
  { label: 'AMOUNT DUE',         key: 'amountDue' },
  { label: 'CONV FEE',           key: 'convFee' },
  { label: 'SERVICE FEE',        key: 'serviceFee' },
  { label: 'TOTAL AMOUNT',       key: 'totalAmount' },
  { label: 'MODIFIED DATE/TIME', key: 'modifiedDateTime' },
  { label: 'STATUS',             key: 'status' },
];



export const BUYLOAD_REBATE_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];


export const BUYLOAD_REBATE_TABLE_SUB_HEADERS = [
  { label: 'NETWORK PROVIDER',   sortable: false, centered: true },
  { label: 'REBATE PERCENTAGE',  sortable: false, centered: true },
  { label: 'CREATED BY',         sortable: false, centered: true },
  { label: 'DATE CREATED',       sortable: false, centered: true },
  { label: 'MODIFY BY',          sortable: false, centered: true },
  { label: 'DATE MODIFIED',      sortable: false, centered: true },
  { label: 'STATUS',             sortable: false, centered: true },
  { label: 'ACTION',             sortable: false, centered: true },
];

export const DISTRIBUTOR_GROUP_TABLE_SUB_HEADERS = [
  { label: 'TYPE',   sortable: false, centered: true },
  { label: 'REBATE PERCENTAGE (%)',  sortable: false, centered: true },
  { label: 'ACTION',  sortable: false, centered: true },
];


export const TRANSFER_FUNDS_TABLE_SUB_HEADERS = [
  { label: 'TRANSACTION ID',   key: 'transactionId' },
  { label: 'DATE / TIME',      key: 'dateTime' },
  { label: 'SENDER NAME',      key: 'senderFirstName' },
  { label: 'SENDER NUMBER',    key: 'senderNumber' },
  { label: 'RECIPIENT NAME',   key: 'recipientFirstName' },
  { label: 'RECIPIENT NUMBER', key: 'recipientNumber' },
  { label: 'TRANSACTION TYPE', key: 'transactionType' },
  { label: 'AMOUNT',       key: 'amount' },
  { label: 'TRANSFER FEE', key: 'transferFee' },
];
